import { render, staticRenderFns } from "./StandardTable.vue?vue&type=template&id=28dbc890&scoped=true&"
import script from "./StandardTable.vue?vue&type=script&lang=js&"
export * from "./StandardTable.vue?vue&type=script&lang=js&"
import style0 from "./StandardTable.vue?vue&type=style&index=0&id=28dbc890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dbc890",
  null
  
)

export default component.exports